import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 AROCL CUSTOMS SOLUTIONS PRIVATE LIMITED. All rights reserved.</p>
    </footer>
  );
}
